<!-- 职称服务 - 申报信息 -->
<template>
  <div>
    <van-steps active-color="#1989FA" :active="0">
      <van-step>填写信息</van-step>
      <van-step>上传资料</van-step>
      <van-step>资格审核</van-step>
      <van-step>办理手续</van-step>
    </van-steps>
    <!-- 职称认定 -->
    <template v-if="type === APPLY_TYPE.ZYJSZGRD">
      <div class="list-title">认定申报信息</div>
      <van-field
        v-model="formData.major"
        label="申报认定专业"
        placeholder="请填写认定专业名称"
        @input="saveCache()"
      />
      <div class="list-item-title">是否第一次申报专业技术资格认定？</div>
      <van-radio-group
        v-model="formData.isFirst"
        class="p-40 flex"
        direction="horizontal"
        @change="
          formData.isPublishArticle = ''
          saveCache()
        "
      >
        <van-radio
          v-for="item in LOGIC_SELECTS"
          :key="item.value"
          class="flex1"
          :name="item.value"
        >
          {{ item.label }}
        </van-radio>
      </van-radio-group>
      <div class="list-item-title">毕业后是否有公开发表论文？</div>
      <van-radio-group
        v-model="formData.isPublishArticle"
        class="p-40 flex"
        direction="horizontal"
        @change="saveCache"
      >
        <van-radio
          v-for="item in LOGIC_SELECTS"
          :key="item.value"
          class="flex1"
          :name="item.value"
        >
          {{ item.label }}
        </van-radio>
      </van-radio-group>
    </template>
    <!-- 职称评审 -->
    <template v-if="type === APPLY_TYPE.ZYJSZGPS">
      <div class="list-title">确认评审申报信息</div>
      <van-field
        v-model="formData.major"
        label="评审申报专业"
        placeholder="请填写评审申报专业名称"
        @input="saveCache()"
      />
      <div class="list-item-title">是否获得专业技术资格证书？</div>
      <van-radio-group
        v-model="formData.isGetCertificate"
        class="p-40 flex"
        direction="horizontal"
        @change="
          clearNumSelect()
          saveCache()
        "
      >
        <van-radio
          v-for="item in LOGIC_SELECTS"
          :key="item.value"
          class="flex1"
          :name="item.value"
        >
          {{ item.label }}
        </van-radio>
      </van-radio-group>
      <template v-if="formData.isGetCertificate === 1">
        <div class="list-item-title">
          获资格证后公开发表独立或第一作者的论文篇数
        </div>
        <sh-picker-field
          key="1"
          v-model="formData.certArticleNum"
          picker-title="篇数"
          :text-data="ARTICLE_NUM_TEXT"
          :columns="ARTICLE_NUM_SELECTS.map((item) => item.label)"
          @input="saveCache()"
        ></sh-picker-field>
        <div class="list-item-title">
          获资格证后本人独立撰写的专业技术分析报告篇数
        </div>
        <sh-picker-field
          key="2"
          v-model="formData.certReportNum"
          picker-title="篇数"
          :text-data="ARTICLE_NUM_TEXT"
          :columns="ARTICLE_NUM_SELECTS.map((item) => item.label)"
          @input="saveCache()"
        ></sh-picker-field>
      </template>
      <template v-if="formData.isGetCertificate === 2">
        <div class="list-item-title">
          毕业后公开发表独立或第一作者的论文篇数
        </div>
        <sh-picker-field
          key="3"
          v-model="formData.graduateArticleNum"
          picker-title="篇数"
          :text-data="ARTICLE_NUM_TEXT"
          :columns="ARTICLE_NUM_SELECTS.map((item) => item.label)"
          @input="saveCache()"
        ></sh-picker-field>
        <div class="list-item-title">
          毕业后本人独立撰写的专业技术分析报告篇数
        </div>
        <sh-picker-field
          key="4"
          v-model="formData.graduateReportNum"
          picker-title="篇数"
          :text-data="ARTICLE_NUM_TEXT"
          :columns="ARTICLE_NUM_SELECTS.map((item) => item.label)"
          @input="saveCache()"
        ></sh-picker-field>
      </template>
      <div class="list-item-title">是否已完成今年的继续教育并领取证书？</div>
      <van-radio-group
        v-model="formData.isContinueAndReceived"
        class="p-40 flex"
        direction="horizontal"
        @change="saveCache()"
      >
        <van-radio
          v-for="item in LOGIC_SELECTS"
          :key="item.value"
          class="flex1"
          :name="item.value"
        >
          {{ item.label }}
        </van-radio>
      </van-radio-group>
    </template>

    <CFooter></CFooter>

    <div class="height-180"></div>
    <div class="fixed-bottom border-box p-40">
      <van-button block round type="info" @click="handleToNext">
        下一步
      </van-button>
    </div>
  </div>
</template>

<script>
import {
  APPLY_TYPE,
  LOGIC_SELECTS,
  ARTICLE_NUM_TEXT,
  ARTICLE_NUM_SELECTS,
  findEnumKey,
} from "@share/enum"
import CFooter from "@/components/CFooter.vue"
import { Toast } from "vant"
import shPickerField from "@/components/sh-picker-field.vue"

export default {
  name: "TitleServiceReportInfo",
  components: {
    CFooter,
    "sh-picker-field": shPickerField,
  },
  data: () => {
    return {
      APPLY_TYPE,
      LOGIC_SELECTS,
      ARTICLE_NUM_TEXT,
      ARTICLE_NUM_SELECTS,
      type: "",
      formData: null,
      isShowCertArticleNum: false,
      isShowCertReportNum: false,
      isShowGraduateArticleNum: false,
      isShowGraduateReportNum: false,
    }
  },
  computed: {},
  created() {
    this.type = Number(this.$route.params.type)
    let formData = {
      major: "",
    }
    if (this.type === APPLY_TYPE.ZYJSZGRD) {
      formData = {
        ...formData,
        isFirst: "",
        isPublishArticle: "",
      }
    } else if (this.type === APPLY_TYPE.ZYJSZGPS) {
      formData = {
        ...formData,
        isGetCertificate: "",
        certArticleNum: undefined,
        certReportNum: undefined,
        graduateArticleNum: undefined,
        graduateReportNum: undefined,
        isContinueAndReceived: "",
      }
    }
    const formDataCache = JSON.parse(
      sessionStorage.getItem("TITLESERVICE_STEP_3") || null
    )
    if (!formDataCache) {
      this.formData = formData
    } else {
      this.setFormParams(formDataCache)
    }
    // sessionStorage.removeItem("TITLESERVICE_STEP_3")
  },
  mounted() {},
  methods: {
    saveCache() {
      sessionStorage.setItem(
        "TITLESERVICE_STEP_3",
        JSON.stringify(this.getFormParams(this.formData))
      )
    },
    /** 下一步 */
    handleToNext() {
      if (!this.checkSubmit()) return
      this.saveCache()
      this.$router.push({
        path: `/apply/upload/${this.type}`,
      })
    },
    /** 确定picker */
    handleConfirmPicker(type, e) {
      const typeLower = type.replace(type[0], type[0].toLowerCase())
      this.formData[typeLower] = findEnumKey(ARTICLE_NUM_TEXT, e)
      this[`isShow${type}`] = false
    },
    /** 取消picker */
    handleCancelPicker(type) {
      this[`isShow${type}`] = false
    },
    /** 清空篇数选择 */
    clearNumSelect() {
      this.formData.certArticleNum = undefined
      this.formData.certReportNum = undefined
      this.formData.graduateArticleNum = undefined
      this.formData.graduateReportNum = undefined
    },
    /** 设置表单参数 */
    setFormParams(data) {
      this.formData = {}
      if (this.type === APPLY_TYPE.ZYJSZGRD) {
        this.formData = {
          ...this.formData,
          major: data.a10014,
          isFirst: data.a10015,
          isPublishArticle: data.a10016,
        }
      } else if (this.type === APPLY_TYPE.ZYJSZGPS) {
        this.formData = {
          ...this.formData,
          major: data.a20013,
          isGetCertificate: data.a20016,
          certArticleNum: data.a20018,
          certReportNum: data.a20019,
          graduateArticleNum: data.a20021,
          graduateReportNum: data.a20022,
          isContinueAndReceived: data.a20020,
        }
      } else {
        throw new Error(`申请类型错误: ${this.type}`)
      }
    },
    /** 获取表单参数 */
    getFormParams() {
      if (this.type === APPLY_TYPE.ZYJSZGRD) {
        return {
          a10014: this.formData.major,
          a10015: this.formData.isFirst,
          a10016: this.formData.isPublishArticle,
        }
      } else if (this.type === APPLY_TYPE.ZYJSZGPS) {
        return {
          a20013: this.formData.major,
          a20016: this.formData.isGetCertificate,
          a20018: Number(this.formData.certArticleNum),
          a20019: Number(this.formData.certReportNum),
          a20021: Number(this.formData.graduateArticleNum),
          a20022: Number(this.formData.graduateReportNum),
          a20020: this.formData.isContinueAndReceived,
        }
      } else {
        throw new Error(`申请类型错误: ${this.type}`)
      }
    },
    /** 校验提交 */
    checkSubmit() {
      if (this.formData.major.length < 2 || this.formData.major.length > 30) {
        Toast("请填写专业名称")
        return false
      }
      if (this.type === APPLY_TYPE.ZYJSZGRD) {
        if (!this.formData.isFirst) {
          Toast("是否第一次申报专业技术资格认定？")
          return false
        }
        if (!this.formData.isPublishArticle) {
          Toast("毕业后是否有公开发表论文？")
          return false
        }
      } else if (this.type === APPLY_TYPE.ZYJSZGPS) {
        if (!this.formData.isGetCertificate) {
          Toast("是否获得专业技术资格证书？")
          return false
        }
        if (this.formData.isGetCertificate === 1) {
          if (this.formData.certArticleNum === undefined) {
            Toast("请选择获资格证后公开发表独立或第一作者的论文篇数")
            return false
          }
          if (this.formData.certReportNum === undefined) {
            Toast("请选择获资格证后本人独立撰写的专业技术分析报告篇数")
            return false
          }
        } else if (this.formData.isGetCertificate === 2) {
          if (this.formData.graduateArticleNum === undefined) {
            Toast("请选择毕业后公开发表独立或第一作者的论文篇数")
            return false
          }
          if (this.formData.graduateReportNum === undefined) {
            Toast("请选择毕业后本人独立撰写的专业技术分析报告篇数")
            return false
          }
        }
        if (!this.formData.isContinueAndReceived) {
          Toast("是否已完成今年的继续教育并领取证书？")
          return false
        }
      }
      return true
    },
  },
}
</script>

<style lang="scss" scope>
@import "~@/assets/style/app";
</style>
